import { SearchState } from "../../State";

/**
 * Algolia has been fully decommissioned and is no longer used by Compona.
 * This service is kept only so existing call sites (catalog search/filters,
 * facets, "new products" on the home page) keep compiling and running
 * without throwing. It performs no network calls and always returns empty,
 * safe results.
 */
export default class AlgoliaServices {
  static async getNewProducts(languageCode: string): Promise<any> {
    return { hits: [] };
  }

  static async getSuggestions(query: string, languageCode: string): Promise<any> {
    return { hits: [] };
  }

  static async getAllFacets(languageCode: string): Promise<any> {
    return { facets: {} };
  }

  static async getProductsByFacetsTreesAndQuery(
    languageCode: string,
    searchState: SearchState,
    excludeFacetFilter: string = "",
  ): Promise<any> {
    return { hits: [], nbHits: 0, facets: {} };
  }
}
